import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import { Log } from "../utils/models/Log";
import { ColumnFiltersState, SortingState } from "@tanstack/react-table";
import { getAllLogs } from "../utils/services/logs.service";
import LogsGridTable from "../components/LogsTable/LogsTable.component";
import LogPreview from "../components/LogPreview/LogPreview.component";
import { UserButtonsLine } from "aw-user-buttons-line";
import { DashboardTypes, MachineConected } from "aw-consts";
import { getLast7days, getTodayDate } from "aw-date-functions";
import { useTheme } from "../utils/contexts/ThemeContext";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { SearchPanel } from "aw-search-panel"; // si el vols
// import { ButtonsLine } from "aw-management-buttons-line"; // si el vols

const LogsModulePage = () => {
    const user = useSelector(selectUser);
    const theme = useTheme()
    const context: IOutletContext = useOutletContext();
    const { t } = useTranslation();

    const logPreviewRef = useRef<HTMLDivElement | null>(null);

    // Dades
    const [logs, setLogs] = useState<Log[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedLog, setSelectedLog] = useState<Log | null>(null);

    // Cerca / filtres
    const [query, setQuery] = useState<string>("");
    const [filters, setFilters] = useState<ColumnFiltersState>([]);
    const [predefinedfiltersValue, setPredifinedFiltersValue] = useState<(number | string)[]>([]);

    // Ordenació i paginació (opcional si ho gestiona la taula)
    const [sorting, setSorting] = useState<SortingState>([]);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
    const [total, setTotal] = useState(0);

    //Dates
    const [iniDate, setIniDate] = useState(getLast7days())
    const [finDate, setFinDate] = useState(getTodayDate())

    useEffect(() => {
        context.setState(t('LogsAndAudit'));
    }, [context, t]);

    // Carrega única
    useEffect(() => {
        setLoading(true);
        getAllLogs(user.token, iniDate, finDate)
            .then((json) => setLogs(json))
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (selectedLog && logPreviewRef.current) {
            logPreviewRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [selectedLog]);

    const onChangeDates = (e: any) => {
        if (e.target.name === "iniDate") {
            setIniDate(e.target.value)
        } else if (e.target.name === "finDate") {
            setFinDate(e.target.value)
        }
    }
    const onReloadClick = () => {
        setLoading(true);
        getAllLogs(user.token, iniDate, finDate,)
            .then((json) => setLogs(json))
            .finally(() => setLoading(false));
        setSelectedLog(null);
    }

    return (
        <>
            <div className='col-12 col-md-12 p-1'>
                <UserButtonsLine
                    downloardData={() => null}
                    role={user.role}
                    connected={MachineConected.Conected}
                    defaultIni={iniDate}
                    defaultFin={finDate}
                    onChangeDates={onChangeDates}
                    onChangeSelect={() => { return false }}
                    onClickReload={onReloadClick}
                    options={[]}
                    selected={{ label: "", value: "" }}
                    DashboardType={DashboardTypes.Company}
                    changeView={() => null}
                    rounded='rounded-1'
                    classNameSecondary='btn-Custom btn-IDGrey'
                    classNameSuccess='btn-Custom btn-IDGreen'
                    containerColor='var(--background-secondary)'
                    dark={theme.theme === "dark" ? true : false}
                    downloadButton={false}
                />
            </div>

            {/* Aquí després col·locarem el component Taula (LogsGrid) */}
            <div className="row border-0 ms-2 me-2" style={{ maxWidth: '100%' }}>
                <div className="col-12 col-md-12 p-1">
                    <LogsGridTable
                        logs={logs}
                        onRowClick={(log) => setSelectedLog(log)}
                        loading={loading}
                        pagination={pagination}
                        setPagination={setPagination}
                        total={total}
                        filters={filters}
                        setFilters={setFilters}
                        sorting={sorting}
                        setSorting={setSorting}
                        manual={false}
                        globalFilter={query}
                        onGlobalFilterChange={setQuery}
                    />
                </div>
                <div className="col-12 col-md-12 p-1" ref={logPreviewRef} >
                    <LogPreview log={selectedLog} onClick={() => setSelectedLog(null)} />
                </div>
            </div>
        </>
    );
};

export default LogsModulePage;
